import { render } from "./Press.vue?vue&type=template&id=0308c5e4&scoped=true"
import script from "./Press.vue?vue&type=script&lang=js"
export * from "./Press.vue?vue&type=script&lang=js"

import "./Press.vue?vue&type=style&index=0&id=0308c5e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0308c5e4"]])

export default __exports__